import store from '@/store';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations } from '@/ts/store/Constants';
import { CameraData, ImageMetaData } from '@/ts/HococoInterfaces';

@Module({name: 'Camera', namespaced: true})
export default class Camera extends VuexModule {
    public isDialogVisible: boolean = false;
    public imageData: string = '';
    public metaData: ImageMetaData = null;
    public recipient: string = 'messages';

    @Mutation
    public RESET_CAMERA_STORE_STATE(): void {
        this.isDialogVisible = false;
        this.imageData       = '';
        this.metaData        = null;
        this.recipient       = 'messages';
    }

    get cameraDialogVisible() {
        return this.isDialogVisible;
    }

    get capturedImageData() {
        return this.imageData;
    }

    get capturedImageMetaData() {
        return this.metaData;
    }

    get hasNewImageData() {
        return (this.imageData !== '');
    }

    @Action
    public SHOW_CAMERA_DIALOG() {
        store.commit(Mutations.SET_CAMERA_DIALOG_VISIBILITY, true);
    }

    @Action
    public CANCEL_IMAGE_CAPTURE() {
        store.commit(Mutations.RESET_CAPTURED_IMAGE_DATA);
        store.commit(Mutations.SET_CAMERA_DIALOG_VISIBILITY, false);
    }

    @Action
    public HIDE_CAMERA_DIALOG() {
        store.commit(Mutations.SET_CAMERA_DIALOG_VISIBILITY, false);
    }

    @Mutation
    public SET_CAMERA_DIALOG_VISIBILITY(visibility: boolean) {
        this.isDialogVisible = visibility;
    }

    @Mutation
    public SAVE_CAPTURED_IMAGE_DATA(imageData: CameraData) {
        this.metaData = imageData.meta;
        this.imageData = imageData.data;
    }

    @Mutation
    public RESET_CAPTURED_IMAGE_DATA() {
        this.imageData = '';
    }

    @Mutation
    public SET_PHOTO_RECIPIENT(recipient: string) {
        this.recipient = recipient;
    }
}

